import React from 'react';
import { Incident } from '../../pages/law/incidentsData';
import { DashboardIcon } from '../ui/DashboardIcon';
import { DetailList } from '../ui/DetailList';
import { SectionHeader } from '../ui/SectionHeader';
import { StatusPill } from '../ui/StatusPill';
import { getIncidentStatusTone } from './incidentUi';

type IncidentSummaryPanelProps = {
  incident: Incident;
  onClose: () => void;
};

export function IncidentSummaryPanel({ incident, onClose }: IncidentSummaryPanelProps) {
  return (
    <aside className="incident-map-details">
      <SectionHeader
        actions={(
          <button className="btn-icon borderless" type="button" aria-label="Close incident summary" onClick={onClose}>
            <DashboardIcon type="close" />
          </button>
        )}
        title={incident.id}
      />
      <p>{incident.note}</p>
      <DetailList
        items={[
          { label: 'Passenger', value: incident.passenger },
          { label: 'Vehicle', value: incident.vehicle },
          { label: 'Status', value: <StatusPill tone={getIncidentStatusTone(incident.status)}>{incident.status}</StatusPill> },
          { label: 'Coordinates', value: `${incident.lat.toFixed(4)}, ${incident.lng.toFixed(4)}` },
        ]}
      />
    </aside>
  );
}
